import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import HubsAPI from '../../../../utils/api/hubsAPI';

const entity = new ReduxRestEntity({
  name: 'hubs',
  api: HubsAPI(),
});

export default entity;
